import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  TextField,
  Paper,
  withStyles,
  Button,
  FormHelperText,
  Select,
  MenuItem,
  Typography,
} from '@material-ui/core';
import classNames from 'classnames';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
// import * as Icons from "@material-ui/icons";
import MUIDataTable from 'mui-datatables';
import DropZone from '../../components/DropZone';
import config from '../../config';
import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import { clearLocalStorage } from '../../utils/common';
import { tenantInfo } from '../../utils/tenantInformation';

export const dropZoneOption = {
  acceptFile: '.jpg,.png,.gif,.jpeg',
  maxSize: 10,
  limitationText: 'สามารถอัพโหลดไฟล์นามสกุล (jpg, png, gif) ครั้งละ 1 ไฟล์และขนาดไม่เกิน 10 MB',
};

class MapsPage extends React.Component {
  dropZoneMaps;

  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    // this.initData = this.initData;
    this.state = {
      tenants: [],
      data: {
        name: '',
        locationId: '',
        imgUrl: '',
        tenantId: null,
      },
      isUploadingMaps: false,
      errorField: {
        name: false,
        locationId: false,
        Imgmap: false,
        tenantId: false,
      },
      routerConnection: [],
    };
  }

  async componentDidMount() {
    const tenants = tenantInfo();
    this.setState({ tenants });

    const { offset, limit, search, sort, order, tenantIds } = this.props.maps.toJS();
    await this.props.maps.getMapList(offset, limit, search, sort, order, tenantIds);
    await this.props.locations.getLocationList(0, 0);
    this.initData();
    this.getRouter();
  }

  initData() {
    const { maps, tenantIds } = this.props.maps.toJS();
    const { id } = this.props.match.params;
    const MapId = Number(id);
    const showData = maps.data.find((item) => item.id === MapId);
    if (showData) {
      this.setState({
        data: {
          id: showData.id,
          name: showData.name,
          imgUrl: showData.imgUrl,
          locationId: showData.locationId,
          tenantId: showData.tenantId,
        },
      });
    } else {
      const tenants = tenantInfo();
      if (tenants.length === 1) {
        tenants.forEach((g) => {
          this.setState({ data: { tenantId: g.id } });
        });
      } else if (tenantIds && tenantIds.length === 1) {
        tenantIds.forEach((id) => {
          this.setState({ data: { tenantId: id } });
        });
      }
    }
  }

  async getRouter() {
    // const { id } = this.props.match.params
    const serialPath = this.props.location.pathname.replace('/app/maps/', '');
    const id = Number(serialPath.replace('/view', ''));
    if (id) {
      await this.props.router.getRouterMap(id);

      const { mapRouters } = this.props.router.toJS();
      let routers = (mapRouters || []).map((val) => {
        val.statusConnection = val.routerConnections.status || 'DISCONNECTED';
        return val;
      });
      this.setState({
        routerConnection: routers,
      });
    }
  }

  onUploadMaps = () => {
    this.setState({ isUploadingMaps: true }, () => {
      this.dropZoneMaps.upload();
    });
  };

  onUploadMapsComplete = async (files) => {
    const path = this.props.match.path.replace('/app/maps/:id/', '');
    const url = files[0].res.url;
    this.setState({ isUploadingMaps: false });
    this.setState((prevState) => {
      prevState.data['imgUrl'] = url;
      return prevState;
    });
    switch (path) {
      case 'edit':
        return await this.upDateMaps('update');
      default:
        return await this.upDateMaps('create');
    }
  };

  upDateMaps = async (task) => {
    const { t } = this.props;
    let { data } = this.state;
    if (task === 'create') {
      try {
        const result = await this.props.maps.createMap(data, task);
        if (result.statusCode === 200) {
          Swal.fire({ html: `<h4>${t('create_success')}`, type: 'success' }).then(async (resultSuccess) => {
            if (resultSuccess.value) {
              this.props.maps.setAction('action', true);
              this.props.history.push('../maps');
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
            }
          });
        }
      } catch (e) {
        if (e.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        } else if (e.statusCode === 400) {
          const msg = e.error.message || `${t('failed_to_create')}`;
          Swal.fire({ html: `<h4>${msg}`, type: 'error' });
        } else {
          Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: 'error' });
        }
      }
    } else {
      Swal.fire({
        html: `<h4>${t('edit_map')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('edit')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          try {
            const result = await this.props.maps.updateMap(data, task);
            if (result.statusCode === 200) {
              Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.history.push('../../maps');
                } else {
                  Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
                }
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else if (e.statusCode === 400) {
              const msg = e.error.message || `${t('failed_to_update')}`;
              Swal.fire({ html: `<h4>${msg}`, type: 'error' });
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
            }
          }
        }
      });
    }
  };

  deleteFileOnClick = async (path) => {
    const { t } = this.props;
    Swal.fire({
      html: `<span class="swal-icon">
                <i
                  class="fa fa-trash-o fa-3x fa-border"
                  style="border: solid .08em #f27474; border-radius: 1.1em; margin-bottom: 35px; margin-top: 22px;">
                </i>
              </span>
              <br/>
              <h4>${t('delete_photo')}`,
      showCancelButton: true,
      cancelButtonText: `${t('cancel')}`,
      confirmButtonText: `${t('delete')}`,
      reverseButtons: true,
      customClass: {
        container: 'my-swal',
      },
    }).then(async (result) => {
      if (result.value) {
        try {
          const result = await this.props.upload.deleteFile(path);
          if (result.statusCode === 200) {
            this.setState((prevState) => {
              prevState.data['imgUrl'] = null;
              return prevState;
            });
            Swal.fire({ html: `<h4>${t('delete_success')}`, type: 'success' });
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        } catch (e) {
          if (e.statusCode === 401) {
            clearLocalStorage();
            window.location.href = '/login';
          } else {
            Swal.fire({ html: `<h4>${t('failed_to_delete')}`, type: 'error' });
          }
        }
      }
    });
  };

  goBack() {
    this.props.maps.setAction('action', true);
    this.props.history.goBack();
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };

  handleCreateMap() {
    if (this.validate()) {
      if (this.dropZoneMaps && this.dropZoneMaps.state.files.length > 0) {
        if (this.dropZoneMaps.state.files[0].size > 1048576) {
          Swal.fire({
            type: 'error',
            text: `ไฟล์ที่อัพโหลดไม่ถูกต้อง รูปต้องมีขนาด ไม่เกิน 1 MB เท่านั้น`,
          });
        } else {
          this.onUploadMaps();
        }
      } else {
        this.upDateMaps('create');
      }
    }
  }

  handleEditMap() {
    if (this.validate()) {
      if (this.dropZoneMaps && this.dropZoneMaps.state.files.length > 0) {
        if (this.dropZoneMaps.state.files[0].size > 1048576) {
          Swal.fire({
            type: 'error',
            text: `ไฟล์ที่อัพโหลดไม่ถูกต้อง รูปต้องมีขนาด ไม่เกิน 1 MB เท่านั้น`,
          });
        } else {
          this.onUploadMaps();
        }
      } else {
        this.upDateMaps('update');
      }
    }
  }

  validate() {
    const { data } = this.state;
    if (
      !data.name ||
      !data.tenantId ||
      !data.locationId ||
      (this.dropZoneMaps && this.dropZoneMaps.state.files.length === 0)
    ) {
      let checkName = !data.name ? true : false;
      let checkTenantId = !data.tenantId ? true : false;
      let checkLocation = !data.locationId ? true : false;
      let checkImgUrl = !data.imgUrl ? true : false;
      this.setState({
        errorField: {
          name: checkName,
          tenantId: checkTenantId,
          locationId: checkLocation,
          imgUrl: checkImgUrl,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          name: false,
          imgUrl: false,
          locationId: false,
          tenantId: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'locationId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          locationId: false,
        },
      });
    }
    if (key === 'tenantId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          tenantId: false,
        },
      });
    }
  }

  onSelectedImage = (e) => {
    let _files = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(_files);
    reader.onload = () => {
      this.setState({
        Imgmap: reader.result,
      });
    };
    this.setState({
      showImage: true,
    });
  };

  triggerInputFile = () => this.fileInput.click();

  renderFormCreate() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const { locations, loading } = this.props.locations.toJS();
    return (
      <React.Fragment>
        <Loader loading={loading || this.state.isUploadingMaps} />
        <Paper className={classes.paper}>
          <PageTitle title={t('create_a_map')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.locationId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                >
                  {(locations.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.locationId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('map')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <DropZone
                className={classes.spaceTop}
                ref={(e) => {
                  this.dropZoneMaps = e;
                }}
                placeholder={t('click_upload_photo')}
                url={`${config.api.url}/${config.api.version}/upload`}
                acceptedFiles={dropZoneOption.acceptFile}
                maxFileSize={dropZoneOption.maxSize}
                dirName='map'
                // fileName=""
                onAllComplete={this.onUploadMapsComplete}
                token={localStorage.getItem('id_token') || null}
              />

              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.imgUrl : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateMap(data)}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderFormEdit() {
    const { classes, t } = this.props;
    const { data, tenants } = this.state;
    const { locations, loading } = this.props.locations.toJS();
    return (
      <React.Fragment>
        <Loader loading={loading || this.state.isUploadingMaps} />
        <Paper className={classes.paper}>
          <PageTitle title={t('edit_a_map')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  <MenuItem fullwidth='true' key={9999999} value={' '}>
                    {t('please_select_tenant')}{' '}
                  </MenuItem>
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
                error={!data.reset ? this.state.errorField.name : false}
              />
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.name : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.locationId}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                >
                  {(locations.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.locationId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('map')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              {data.imgUrl ? (
                <div className={`${classes.imgPreviewContainer} ${classes.spaceTop}`}>
                  <div
                    className={classes.imgPreviewDel}
                    onClick={() => {
                      this.deleteFileOnClick(data.imgUrl);
                    }}
                  >
                    <i className='fa fa-times-circle-o' aria-hidden='true' />
                  </div>
                  <div
                    className={classNames(classes.imgPreview, classes.rounded)}
                    style={{
                      background: `url("${data.imgUrl}") center no-repeat`,
                    }}
                  />
                </div>
              ) : (
                <DropZone
                  className={classes.spaceTop}
                  ref={(e) => {
                    this.dropZoneMaps = e;
                  }}
                  placeholder={t('click_upload_photo')}
                  url={`${config.api.url}/${config.api.version}/upload`}
                  acceptedFiles={dropZoneOption.acceptFile}
                  maxFileSize={dropZoneOption.maxSize}
                  dirName='map'
                  // fileName=""
                  onAllComplete={this.onUploadMapsComplete}
                  token={localStorage.getItem('id_token') || null}
                />
              )}

              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.imgUrl : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleEditMap(data)}
                  className={classes.button}
                >
                  {t('edit')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }

  renderView() {
    const { classes, t } = this.props;
    const { routerConnection, data, tenants } = this.state;
    const { locations } = this.props.locations.toJS();
    const { loading } = this.props.maps.toJS();
    const columns = [
      {
        name: 'name',
        label: `${t('name')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{row[0]}</div>;
          },
        },
      },
      {
        name: 'serial',
        label: `${t('router_id')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            return <div className={classes.columnWidth200}>{row[1]}</div>;
          },
        },
      },
      {
        name: 'statusConnection',
        label: `${t('activation_status')}`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            const row = tableMeta.rowData;
            let result;
            switch (row && row[2]) {
              case 'CONNECTED':
                result = (
                  <div style={{ minWidth: '150px', backgroundColor: '#60CD9B', color: '#fff', textAlign: 'center' }}>
                    ON
                  </div>
                );
                break;
              case 'DISCONNECTED':
                result = (
                  <div style={{ minWidth: '150px', backgroundColor: '#E87352', color: '#fff', textAlign: 'center' }}>
                    OFF
                  </div>
                );
                break;
              default:
                break;
            }
            return result;
          },
        },
      },
    ];

    return (
      <React.Fragment>
        <Loader loading={loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('view_a_map')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tenant')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.tenantId || ' '}
                  inputProps={{
                    name: 'tenantId',
                    id: 'tenantId',
                  }}
                  disabled
                >
                  {(tenants || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.tenantId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('name')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                required
                id='name'
                name='name'
                fullWidth
                value={data.name}
                variant='outlined'
                margin='dense'
                disabled
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} required />
            </Grid>
            <Grid item xs={12} sm={10}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.locationId}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                  disabled
                >
                  {(locations.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('map')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <div className={`${classes.imgPreviewContainer} ${classes.spaceTop}`}>
                <div
                  className={classNames(classes.imgPreview, classes.rounded)}
                  style={{
                    background: `url("${data.imgUrl}") center no-repeat`,
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </Paper>

        <div className={classes.TitlePage}>
          <Typography className={classes.typo} variant='h6'>
            {t('router_in_map')}
          </Typography>
        </div>
        <Grid container spacing={32} className={classes.mainContain}>
          <Grid item xs={12}>
            <MUIDataTable
              data={routerConnection}
              columns={columns}
              options={{
                selectableRows: 'none',
                selectableRowsOnClick: false,
                filter: false,
                filterType: 'none',
                search: false,
                download: false,
                viewColumns: false,
                print: false,
                pagination: false,
                responsive: 'scrollFullHeight',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <div className={classes.buttons}>
              <Button className={classes.button} onClick={this.goBack}>
                {t('back')}
              </Button>
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }

  render() {
    const path = this.props.match.path.replace('/app/maps/:id/', '');
    let result;
    switch (path) {
      case 'edit':
        result = this.renderFormEdit();
        break;
      case 'view':
        result = this.renderView();
        break;
      default:
        result = this.renderFormCreate();
        break;
    }
    return result;
  }
}
const styles = (theme) => ({
  spaceTop: {
    marginTop: '10px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  mainContain: {
    padding: 16,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  paperImg: {
    padding: '100px',
    width: '100%',
    border: '2px dashed #e9ecef',
    boxShadow: 'none',
    backgroundColor: '#fafafa',
    textAlign: 'center',
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  input: {
    display: 'none',
  },
  icon: {
    color: '#ccc',
    fontSize: '5rem',
  },
  title: {
    textTransform: 'capitalize',
  },
  imgPreviewContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  imgPreviewDel: {
    color: '#bf1e2e',
    position: 'absolute',
    right: 0,
    fontSize: '1.8rem',
    marginTop: '-21px',
    marginRight: '-11px',
    '&:hover, &:focus': {
      fontSize: '2.2rem',
      cursor: 'pointer',
    },
  },
  imgPreview: {
    backgroundSize: 'contain !important',
    height: '300px',
    border: '1px solid #ced4da',
  },
  imgPreviewDefault: {
    backgroundSize: '100px 100px !important',
    height: '300px',
    border: '1px solid #ced4da',
  },
  TitlePage: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 4,
    background: '#049588',
    height: '90px',
    margin: '-24px',
  },
  typo: {
    color: 'white',
    padding: '30px',
  },
  columnWidth200: {
    maxWidth: '200px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
export const page = inject('locations', 'maps', 'upload', 'router')(observer(MapsPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
